import React, { useState, useContext, useEffect } from 'react';
import { Modal, Box, Fab, TextField, Tooltip, Zoom } from '@mui/material';
import QRCode from 'qrcode.react';
import { useTheme } from '@mui/material/styles';
import { openTheDoor, getSharedBookLink, updateLightsState, getLightsState } from './api';
import { useHookState } from './NotificationApiHook';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import CheckIcon from '@mui/icons-material/Check';
import { PlaceContext } from '../contexts/PlaceContext';
import LightbulbIcon from '@mui/icons-material/Lightbulb';

const BookingModal = ({ open, onClose, booking, token }) => {
  const theme = useTheme();
  const { notificationState } = useHookState();
  const [load, setLoad] = useState(false);
  const [anotherLoad, setAnotherLoad] = useState(false);
  const [sharedLink, setSharedLink] = useState('');
  const [copied, setCopied] = useState(false);
  const { placeId } = useContext(PlaceContext);
  const [actualState, setActualState] = useState(null);
  console.log('Booking id', booking.id);

  const handleOpenTheDoor = async () => {
    try {
      await openTheDoor(notificationState, token, placeId);
    } catch (error) {
      console.error('Error during opening the door:', error);
    } finally {
      console.log(load);
      setLoad(false);
      closeModal();
    }
  };

  const handleShareOpener = async () => {
    try {
      const data = await getSharedBookLink(booking.id, notificationState, token);
      setSharedLink(data);
    } catch (error) {
      console.error('Error during opening the door:', error);
    } finally {
      console.log(load);
      setAnotherLoad(false);
    }
  };

  const handleTrunTheLight = async () => {
    const state = { [booking.table_number]: 0 };
    if (actualState[booking.table_number] == 0) {
      notificationState.openNotification(`Свет уже включен <br> приятной игры!`);
      setAnotherLoad(false);
      return;
    }
    try {
      await updateLightsState(placeId, token, notificationState, state);
      notificationState.openNotification(`Свет включен!`);
      setActualState({ [booking.table_number]: 0 });
    } catch (error) {
      console.error('Error during turning the lights:', error);
    } finally {
      setAnotherLoad(false);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(sharedLink);
    setCopied(true);
  };

  const closeModal = () => {
    setSharedLink('');
    setCopied(false);
    onClose();
  };

  useEffect(() => {
    if (placeId == 2) {
      getLightsState(placeId, token, notificationState)
        .then((actual_state) => {
          setActualState(actual_state);
        })
        .catch((error) => {
          console.error('Error fetching books for day:', error);
        });
    }
  }, []);

  return (
    <Modal
      open={open}
      onClose={closeModal}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          maxHeight: 'calc(100svh)',
          minHeight: 'calc(100svh - 350px)',
        }}
      >
        <Box
          sx={{
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 4,
            textAlign: 'center',
          }}
        >
          <QRCode
            value={booking.id ? booking.id.toString() : ''}
            size={256}
          />
        </Box>
        <Fab
          color='primary'
          onClick={() => {
            setLoad(true);
            handleOpenTheDoor();
          }}
          disabled={load}
          sx={{
            backgroundColor: theme.palette.primary.main,
            position: 'sticky',
            bottom: '58px',
            display: 'block',
            width: '100%',
            maxWidth: '600px',
            height: '80px',
            lineHeight: '30px',
            padding: '15px',
            marginTop: '15px',
            zIndex: '98',
            borderRadius: '0',

            '&.Mui-disabled': {
              backgroundColor: '#4b4b4b',
              color: theme.palette.primary.contrastText,
            },
          }}
        >
          {!load ? `Открыть дверь` : `Дверь открыта`}
        </Fab>
        {!sharedLink ? (
          <Fab
            color='primary'
            onClick={() => {
              setAnotherLoad(true);
              handleShareOpener();
            }}
            disabled={anotherLoad}
            sx={{
              backgroundColor: theme.palette.primary.main,
              position: 'sticky',
              bottom: '58px',
              display: 'block',
              width: '100%',
              maxWidth: '600px',
              height: '80px',
              lineHeight: '30px',
              padding: '15px',
              marginTop: '15px',
              zIndex: '98',
              borderRadius: '0',
              '&.Mui-disabled': {
                backgroundColor: '#4b4b4b',
                color: theme.palette.primary.contrastText,
              },
            }}
          >
            Поделиться бронью
          </Fab>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', marginTop: '15px' }}>
            <Tooltip
              TransitionComponent={Zoom}
              enterDelay={100}
              title='Можно отправить партнеру ссылку для входа в зал'
              // sx={{
              //   '&.MuiTooltip-tooltip': {
              //     fontSize: '15px',
              //   },
              // }}
            >
              <TextField
                variant='outlined'
                value={sharedLink}
                sx={{
                  '&.MuiFormControl-root ': {
                    overflow: 'hidden',
                    width: '320px',
                    borderRadius: 1,
                    backgroundColor: '#fff',
                  },
                }}
                InputProps={{
                  endAdornment: copied ? (
                    <CheckIcon
                      color='primary'
                      sx={{ marginLeft: '10px', cursor: 'pointer' }}
                    />
                  ) : (
                    <FileCopyIcon
                      color='primary'
                      onClick={copyToClipboard}
                      sx={{ marginLeft: '10px', cursor: 'pointer' }}
                    />
                  ),
                }}
              />
            </Tooltip>
          </Box>
        )}
        {placeId == 2 && (
          <Fab
            color='primary'
            onClick={() => {
              setAnotherLoad(true);
              handleTrunTheLight();
            }}
            disabled={anotherLoad}
            sx={{
              backgroundColor: theme.palette.primary.main,
              width: '30%',
              height: '80px',
              marginTop: '15px',
              zIndex: '98',
              borderRadius: '0',
              '&.Mui-disabled': {
                backgroundColor: '#4b4b4b',
                color: theme.palette.primary.contrastText,
              },
            }}
          >
            <LightbulbIcon sx={{ color: '#fff972' }} />
          </Fab>
        )}
      </Box>
    </Modal>
  );
};

export default BookingModal;
